import { useMutation } from "@tanstack/react-query";

import {
  type FetchResponseOfError,
  postAuthRegisterActor,
  type RegisterActorRequest,
} from "Infrastructure/Api/Api";
import { ApiCallError, isSuccessResponse } from "Infrastructure/Api/ApiUtils";

export function useRegisterActorMutation() {
  return useMutation({
    mutationFn: (request: RegisterActorRequest) =>
      postAuthRegisterActor(request),
    onSuccess: (data) => {
      if (!isSuccessResponse(data)) {
        throw new ApiCallError(data as unknown as FetchResponseOfError);
      }
    },
  });
}
